import { useState } from 'react';
import { useTransientStatus } from '../../../shared/hooks/useTransientStatus.js';
import { saveCollectedRaidBossMetadata } from '../../raid-season/api/raidBossMetadataApi.js';
import { collectRaidBridgeNow, RAID_BRIDGE_USERSCRIPT_VERSION } from '../api/raidBridgeInstaller.js';
import { useRaidBridge } from '../hooks/useRaidBridge.js';

function collectErrorMessage(error) {
  const raw = error instanceof Error ? error.message : String(error || '');
  if (raw === 'tampermonkey_bridge_timeout') return `수집기 v${RAID_BRIDGE_USERSCRIPT_VERSION} 응답이 없습니다.`;
  if (raw === 'outdated_bridge_token') return '구형 토큰입니다. 레이드 수집기에서 새 공용 토큰을 저장해주세요.';
  if (raw === 'invalid_bridge_token') return '공용 토큰을 다시 저장해주세요.';
  if (/로그인|유니온 정보를 확인하지 못했습니다/i.test(raw)) return 'BlablaLink 로그인 상태를 확인해주세요.';
  return raw || '실전 데이터를 불러오지 못했습니다.';
}

export function RaidBridgeTopbarCollectButton({ compact = false }) {
  const bridge = useRaidBridge();
  const [working, setWorking] = useState(false);
  const { message: notice, show: showNotice, clear: clearNotice } = useTransientStatus();
  const seasonNo = Number(bridge.selectedSeasonNo || bridge.activeSeasonNo || 0);
  const collectorReady = Boolean(bridge.collectorReady);

  if (!bridge.loading && !bridge.canManage) return null;

  const collect = async () => {
    if (working || bridge.loading || !seasonNo || !collectorReady) return;
    setWorking(true);
    clearNotice();
    try {
      const result = await collectRaidBridgeNow({ seasonNo });
      try {
        await saveCollectedRaidBossMetadata({ seasonNo: result.seasonNo, bosses: result.bosses });
      } catch {
        // 실전 기록 반영은 성공했으므로 상단 빠른 수집을 실패 처리하지 않는다.
      }
      window.dispatchEvent(new CustomEvent('dororaid:raid-overview-changed'));
      window.dispatchEvent(new CustomEvent('dororaid:union-roster-changed'));
      showNotice({ type: 'success', message: `${result.seasonNo}차 ${result.reflectedCount}개 반영` });
    } catch (error) {
      showNotice({ type: 'error', message: collectErrorMessage(error), transient: false });
      await bridge.probeInstaller();
    } finally {
      setWorking(false);
    }
  };

  const blockedMessage = bridge.tokenOutdated
    ? '구형 토큰입니다. 레이드 수집기에서 새 공용 토큰을 저장해주세요.'
    : !collectorReady && !bridge.loading
      ? '레이드 수집기 처음 설정을 완료해주세요.'
      : '';
  const visibleNotice = notice || (!compact ? blockedMessage : '');

  return (
    <div className={`raid-bridge-topbar-collect ${compact ? 'compact' : ''}`}>
      <button
        type="button"
        disabled={bridge.loading || !seasonNo || !collectorReady || working}
        onClick={collect}
        title={blockedMessage || (seasonNo ? `${seasonNo}차 실전 데이터 바로 불러오기` : '수집할 차수가 없습니다.')}
        aria-label={working ? '실전 데이터 불러오는 중' : '실전 데이터 바로 불러오기'}
      >
        <span aria-hidden="true">↻</span>
        {compact ? null : <strong>{working ? '불러오는 중…' : '실전 불러오기'}</strong>}
      </button>
      {visibleNotice ? <small role="status">{visibleNotice}</small> : null}
    </div>
  );
}
